module.exports = __webpack_public_path__ + "img/signHelp.42203bd2.png";